// =============================================================================
// bwc Sitepackage - Main JavaScript
// =============================================================================
// Build:  cd build/frontend && npm run js   →  main.js (bundled)
// =============================================================================

// 1. jQuery global verfügbar machen (für Legacy-Code, DataTables, etc.)
// import './jquery-global.js';

// 2. Bootstrap 5.3 (komplett laden für Modals, Accordion, Dropdowns, etc.)
import * as bootstrap from 'bootstrap';

// 3. DataTables (optional - bei Bedarf einkommentieren)
// import 'datatables.net';
// import 'datatables.net-bs5';
// import 'datatables.net-fixedheader';
// import 'datatables.net-responsive';

// =============================================================================
// bwc Sitepackage - Main JavaScript
// =============================================================================

// -------------------------------------------------------------------------
// Lightbox initialisieren (bs5-lightbox)
// -------------------------------------------------------------------------
import Lightbox from 'bs5-lightbox';

document.addEventListener('DOMContentLoaded', function () {
  // Hier dein eigener JavaScript-Code

  // -------------------------------------------------------------------------
  // Bootstrap Tooltips initialisieren
  // -------------------------------------------------------------------------
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    new bootstrap.Tooltip(el);
  });

  // -------------------------------------------------------------------------
  // Bootstrap Popovers initialisieren
  // -------------------------------------------------------------------------
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
    new bootstrap.Popover(el);
  });

  // -------------------------------------------------------------------------
  // Lightbox initialisieren (bs5-lightbox)
  // -------------------------------------------------------------------------
  const lightboxTriggers = document.querySelectorAll('[data-toggle="lightbox"]');

  lightboxTriggers.forEach(el => {
    if (!el.dataset.size) el.dataset.size = 'xl';
    el.addEventListener('click', Lightbox.initialize);

    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        el.click();
      }
    });
  });


  // -------------------------------------------------------------------------
// Dekorativen Teaser-Pfeil klickbar machen
// -------------------------------------------------------------------------
  document.addEventListener('click', (event) => {
    const arrowLink = event.target.closest('[data-arrow-link-url]');

    if (!arrowLink) {
      return;
    }

    const url = arrowLink.dataset.arrowLinkUrl;

    if (url) {
      window.location.assign(url);
    }
  });



  // -------------------------------------------------------------------------
// Accordion: korrektes Scrollen zur Headline nach dem Öffnen
// Behebt das "scrollt zu weit hoch"-Problem mit Sticky Header
// -------------------------------------------------------------------------
  document.querySelectorAll('.accordion').forEach(accordion => {
    accordion.addEventListener('shown.bs.collapse', function (e) {
      const button = accordion.querySelector(
        `[data-bs-target="#${e.target.id}"], [aria-controls="${e.target.id}"]`
      );
      if (!button) return;

      const header      = document.querySelector('.site-header');
      const headerH     = header ? header.getBoundingClientRect().height : 0;
      const buttonTop   = button.getBoundingClientRect().top + window.scrollY;
      const scrollTo    = buttonTop - headerH - 16;

      window.scrollTo({ top: scrollTo, behavior: 'smooth' });
    });
  });



  // -------------------------------------------------------------------------
  // Smooth Scroll für Anchor-Links + Accordion-Öffnung
  // -------------------------------------------------------------------------
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (!href || href === '#') {
        return;
      }

      const target = document.querySelector(href);
      if (!target) {
        return;
      }

      e.preventDefault();

      const accordionCollapse = target.closest('.accordion-collapse');

      if (accordionCollapse && !accordionCollapse.classList.contains('show')) {
        const collapseInstance = bootstrap.Collapse.getOrCreateInstance(accordionCollapse, {
          toggle: false
        });

        accordionCollapse.addEventListener('shown.bs.collapse', () => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, { once: true });

        collapseInstance.show();
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });


  // -------------------------------------------------------------------------
  // Scroll to top Button
  // -------------------------------------------------------------------------
  const scrollToTopButton = document.getElementById('scrollToTop');
  if (scrollToTopButton) {
    scrollToTopButton.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }


  // -------------------------------------------------------------------------
  // Sticky Header: Shrink-Animation beim Scrollen
  // -------------------------------------------------------------------------
  const stickyThreshold = 80;
  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = `position:absolute; top:0; left:0; width:1px; height:${stickyThreshold}px; pointer-events:none;`;
  document.body.prepend(sentinel);

  new IntersectionObserver(
    ([entry]) => document.body.classList.toggle('is-scrolled', !entry.isIntersecting),
    { threshold: 0 }
  ).observe(sentinel);



  // =============================================================================
  // Navigation - Submenu (details/summary)
  // =============================================================================
  //
  // Verhalten:
  // - <details>/<summary> macht das Toggle nativ (kein JS noetig zum Aufklappen)
  // - Tastatur-Navigation funktioniert nativ
  // - Klick auf <summary> darf das umschliessende Bootstrap-Dropdown NICHT
  //   schliessen - dafuer stopPropagation
  // - Wenn Bootstrap-Dropdown dennoch geschlossen wird (Klick ausserhalb, Klick
  //   auf anderen Top-Level-Eintrag), schliessen wir auch alle offenen <details>
  // =============================================================================

  (() => {

    // Klick auf <summary> nicht zum Dropdown durchreichen
    document.querySelectorAll('.has-submenu summary').forEach(summary => {
      summary.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

    // Wenn Bootstrap-Dropdown schliesst: alle <details> mit schliessen
    document.querySelectorAll('.dropdown').forEach(dropdown => {
      dropdown.addEventListener('hide.bs.dropdown', () => {
        dropdown.querySelectorAll('details[open]').forEach(details => {
          details.removeAttribute('open');
        });
      });
    });

  })();



  // =============================================================================
  // Popup Auto-Open
  // =============================================================================
  //
  // Findet alle Modals mit data-auto-open="true" und oeffnet sie
  // nach der konfigurierten Verzoegerung.
  // =============================================================================

  (() => {

    const autoOpenModals = document.querySelectorAll('[data-auto-open="true"]');

    autoOpenModals.forEach(modalEl => {
      const delay = parseInt(modalEl.dataset.autoOpenDelay || '1', 10);

      setTimeout(() => {
        const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }, delay * 1000);
    });

  })();



  // =============================================================================
  // Header-Hoehe als CSS-Variable bereitstellen (fuer Megamenu-Positionierung)
  // =============================================================================
  const header = document.querySelector('.site-header');

  if (header) {
    let rafId = null;

    const syncHeaderHeight = () => {
      // Menue offen (oder gerade am Auf-/Zuklappen)? -> letzten Wert behalten
      const openMenu = document.querySelector(
        '.main-nav .navbar-collapse.show, .main-nav .navbar-collapse.collapsing'
      );
      if (openMenu) return;

      // rAF entkoppelt das Schreiben vom Messen -> keine ResizeObserver-Warnung
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        document.documentElement.style.setProperty(
          '--header-height', `${header.getBoundingClientRect().height}px`
        );
        rafId = null;
      });
    };

    syncHeaderHeight();
    new ResizeObserver(syncHeaderHeight).observe(header);

    // Nach dem Schliessen des Menues einmal sauber nachmessen
    document.querySelectorAll('.main-nav .navbar-collapse').forEach(el => {
      el.addEventListener('hidden.bs.collapse', syncHeaderHeight);
    });
  }




  // -------------------------------------------------------------------------
  // Animation beim Scrollen
  // -------------------------------------------------------------------------
  // deaktiviert, da Problematisch unter Chrome. Alternativ Lenis nutzen (https://github.com/darkroomengineering/lenis)
  /*
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Für Barrierefreiheit: kein künstliches Smooth Scrolling,
    // wenn Nutzer reduzierte Bewegung eingestellt haben.
    if (prefersReducedMotion) return;

    let currentY = window.scrollY;
    let targetY = window.scrollY;
    let animationFrame = null;

    const ease = 0.075;        // kleiner = langsamer/weicher, größer = direkter
    const wheelFactor = 0.8;  // kleiner = weniger Strecke pro Scroll
    const minDelta = 0.5;

    function getMaxScroll() {
      return document.documentElement.scrollHeight - window.innerHeight;
    }

    function animate() {
      const diff = targetY - currentY;

      if (Math.abs(diff) < minDelta) {
        currentY = targetY;
        window.scrollTo(0, currentY);
        animationFrame = null;
        return;
      }

      currentY += diff * ease;
      window.scrollTo(0, currentY);

      animationFrame = requestAnimationFrame(animate);
    }

    function startAnimation() {
      if (!animationFrame) {
        animationFrame = requestAnimationFrame(animate);
      }
    }

    window.addEventListener('wheel', function (e) {
      // Nur normales vertikales Scrollen übernehmen
      if (e.ctrlKey) return;

      const preventLenisLikeAreas = e.target.closest(
        '[data-smooth-scroll-prevent], .modal, .offcanvas, .dropdown-menu'
      );

      if (preventLenisLikeAreas) return;

      e.preventDefault();

      currentY = window.scrollY;

      targetY += e.deltaY * wheelFactor;
      targetY = Math.max(0, Math.min(targetY, getMaxScroll()));

      startAnimation();
    }, { passive: false });

    // Falls der User per Tastatur, Ankerlink oder Browser anderweitig scrollt,
    // interne Werte synchron halten.
    window.addEventListener('scroll', function () {
      if (!animationFrame) {
        currentY = window.scrollY;
        targetY = window.scrollY;
      }
    }, { passive: true });
  })();
  */


});
